import axios from 'axios'
import {
  LOAD_ADMIN_SUCCESS,
  LOGIN_ADMIN_ERROR,
  LOADING_COMPLETE,
  LOGIN_ADMIN,
  LOGOUT_ADMIN,
  RESET_AUTH_ERRORS,
} from './constants'

export const login = (formObj, setFormObj) => async (dispatch) => {
  setFormObj((data) => ({ ...data, state: 'submitting' }))
  const config = {
    headers: { 'Content-Type': 'application/json' },
  }
  const { email, password } = formObj
  const body = JSON.stringify({ email, password })
  try {
    let res = await axios.post(`${process.env.REACT_APP_API_URI}/xcb/api/auth/admin`, body, config)
    const { content } = res.data
    dispatch({
      type: LOGIN_ADMIN,
      payload: content.token,
    })
    setFormObj((data) => ({
      ...data,
      state: 'submitted',
      emailStatus: 'is-valid',
    }))
  } catch (err) {
    setFormObj((data) => ({
      ...data,
      state: 'idle',
      emailStatus: 'is-invalid',
    }))
    const errResp = err.response
    if (!errResp) {
      dispatch({
        type: LOGIN_ADMIN_ERROR,
        payload: [{ msg: 'Please try again' }],
      })
    } else dispatch({ type: LOGIN_ADMIN_ERROR, payload: errResp.data.errors })
  }
}

export const loadAdmin = (token, setFormObj) => async (dispatch) => {
  try {
    if (!token) {
      dispatch({ type: LOADING_COMPLETE, payload: false })
    } else {
      const config = {
        headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
      }
      let res = await axios.get(`${process.env.REACT_APP_API_URI}/xcb/api/admin`, config)
      dispatch({
        type: LOAD_ADMIN_SUCCESS,
        payload: { ...res.data.content, token },
      })
    }
  } catch (err) {
    setFormObj((data) => ({
      ...data,
      state: 'idle',
      emailStatus: 'is-invalid',
    }))
    const errResp = err.response
    if (!errResp) {
      dispatch({
        type: LOGIN_ADMIN_ERROR,
        payload: [{ msg: 'Please try again' }],
      })
    } else dispatch({ type: LOGIN_ADMIN_ERROR, payload: errResp.data.errors })
  }
}

export const logout = () => async (dispatch) => {
  dispatch({ type: LOGOUT_ADMIN, payload: null })
}

export const resetAuthErrors = () => async (dispatch) => {
  dispatch({ type: RESET_AUTH_ERRORS })
}

//make remaining reducer
//configure login useEffect
//configure emailStatus
//configure AuthRoutes(HOC)
